// import React from 'react';

// const ErpSection = () => {
//   const HeroImage = ({ extraClass = '' }) => (
//     <div style={styles.rightImage} className={`erp-right ${extraClass}`}>
//      <img
//   src="/assets/img/Erpsection/E1.avif"
//   alt="ERP Dashboard"
//   style={styles.heroImg}
//   className="erp-img"
// />
//       <div style={styles.floatingCard} className="erp-float-card">
//         <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>Production Growth</p>
//         <h3 style={{ margin: 0, color: '#00ff88' }}>+28%</h3>
//       </div>
//     </div>
//   );

//   return (
//     <div style={styles.wrapper}>
//       <div style={styles.container} className="erp-container">

//         {/* Left Side: Content */}
//         <div style={styles.leftContent} className="erp-left">
//           <p style={styles.badge} className="erp-badge">
//             #1 ERP SOLUTIONS & DIGITAL LIFECYCLE TRANSFORMATION PARTNER
//           </p>

//           {/* Mobile only: Image below badge */}
//           <HeroImage extraClass="erp-img-mobile" />

//           <h1 style={styles.mainHeading} className="erp-heading">
//             Enterprise Resource Planning (ERP)<br />
//             Software Services
//           </h1>
//           <div style={styles.highlightText} className="erp-highlight">
//             <p>• 15+ Years of Enterprise Software Experience</p>
//             <p>• Industry-Focused ERP Consultants & Engineers</p>
//             <p>• Manufacturing, Textile & Distribution Domain Experts</p>
//           </div>
//           {/* <p style={styles.description} className="erp-desc">
//             Streamline your business operations and eliminate data silos with a unified ERP platform.
//             Our ERP solutions help you seamlessly manage finance, inventory, production, sales, and HR—enabling real-time visibility, process automation, compliance, and scalable growth through a secure and flexible digital foundation.
//           </p> */}

//           <button style={styles.ctaButton} className="erp-btn">
//             Request a demo
//             <svg
//               width="20" height="20" viewBox="0 0 24 24"
//               fill="none" stroke="currentColor" strokeWidth="2"
//               strokeLinecap="round" strokeLinejoin="round"
//               style={{ marginLeft: '10px' }}
//             >
//               <line x1="5" y1="12" x2="19" y2="12"></line>
//               <polyline points="12 5 19 12 12 19"></polyline>
//             </svg>
//           </button>
//         </div>

//         {/* Right Side: Desktop only */}
//         <HeroImage extraClass="erp-img-desktop" />

//       </div>

//       <style>{`

//         /* Desktop: show right image, hide mobile image */
//         .erp-img-mobile {
//           display: none !important;
//         }
//         .erp-img-desktop {
//           display: flex !important;
//         }

//         /* ── TABLET: 768px ── */
//         @media (max-width: 768px) {
//           .erp-container {
//             grid-template-columns: 1fr !important;
//             gap: 0px !important;
//           }
//           /* Hide desktop right image */
//           .erp-img-desktop {
//             display: none !important;
//           }
//           /* Show mobile image (below badge) */
//           .erp-img-mobile {
//             display: flex !important;
//             position: relative !important;
//             max-width: 360px !important;
//             width: 100% !important;
//             margin: 0 0 24px 0 !important;
//           }
//           .erp-img-mobile .erp-float-card {
//             right: 0px !important;
//           }
//           .erp-heading {
//             font-size: 28px !important;
//           }
//           .erp-badge {
//             font-size: 12px !important;
//           }
//         }

//         /* ── MOBILE: 480px ── */
//         @media (max-width: 480px) {
//           .erp-img-mobile {
//             max-width: 300px !important;
//           }
//           .erp-heading {
//             font-size: 21px !important;
//             letter-spacing: 0 !important;
//           }
//           .erp-highlight {
//             font-size: 14px !important;
//             line-height: 1.7 !important;
//           }
//           .erp-desc {
//             font-size: 13px !important;
//           }
//           .erp-btn {
//             font-size: 14px !important;
//             padding: 10px 20px !important;
//           }
//           .erp-float-card {
//             top: 10px !important;
//             padding: 10px 12px !important;
//           }
//         }

//         /* ── SMALL MOBILE: 360-390px ── */
//         @media (max-width: 390px) {
//           .erp-img-mobile {
//             max-width: 240px !important;
//           }
//           .erp-heading {
//             font-size: 17px !important;
//             line-height: 1.35 !important;
//           }
//           .erp-badge {
//             font-size: 9.5px !important;
//             letter-spacing: 0.8px !important;
//             margin-bottom: 14px !important;
//           }
//           .erp-highlight {
//             font-size: 12.5px !important;
//           }
//           .erp-desc {
//             font-size: 12px !important;
//             margin-bottom: 18px !important;
//           }
//           .erp-btn {
//             font-size: 13px !important;
//             padding: 9px 16px !important;
//           }
//           .erp-float-card h3 {
//             font-size: 15px !important;
//           }
//           .erp-float-card p {
//             font-size: 10px !important;
//           }
//           .erp-img {
//             border-radius: 10px !important;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   wrapper: {
//     backgroundColor: '#05070a',
//     minHeight: '100vh',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
//     color: '#fff',
//     padding: '80px 5%',
//   },
//   container: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '50px',
//     maxWidth: '1200px',
//     width: '100%',
//     alignItems: 'center',
//   },
//   leftContent: { textAlign: 'left' },
//   badge: {
//     fontSize: '14px',
//     fontWeight: 'bold',
//     letterSpacing: '1.5px',
//     marginBottom: '20px',
//     opacity: 0.8,
//     display: 'block',
//   },
//   mainHeading: {
//     fontSize: '35px',
//     lineHeight: '1.2',
//     marginBottom: '20px',
//     fontWeight: '800',
//     color: '#4facfe',
//     letterSpacing: '0.5px',
//   },
//   highlightText: {
//     marginBottom: '20px',
//     fontSize: '16px',
//     lineHeight: '1.8',
//     fontFamily: 'Open Sans, sans-serif',
//   },
//   // description: {
//   //   fontSize: '14px',
//   //   color: '#aaa',
//   //   lineHeight: '1.6',
//   //   marginBottom: '30px',
//   //   maxWidth: '500px',
//   //   fontFamily: 'Open Sans, sans-serif',
//   // },
//   ctaButton: {
//     backgroundColor: '#007bff',
//     color: 'white',
//     padding: '12px 25px',
//     border: 'none',
//     borderRadius: '25px',
//     fontSize: '16px',
//     cursor: 'pointer',
//     transition: '0.3s',
//     display: 'flex',
//     alignItems: 'center',
//   },
//   rightImage: {
//     position: 'relative',
//     display: 'flex',
//     justifyContent: 'center',
//   },
//   heroImg: {
//     width: '100%',
//     borderRadius: '15px',
//     boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
//     border: '1px solid #333',
//   },
//   floatingCard: {
//     position: 'absolute',
//     top: '20px',
//     right: '-20px',
//     backgroundColor: '#1a1d23',
//     padding: '15px',
//     borderRadius: '10px',
//     border: '1px solid #333',
//     boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
//   }
// };

// export default ErpSection;

/*change design*/

// import React from 'react';

// const ErpSection = () => {
//   const HeroImage = ({ extraClass = '' }) => (
//     <div style={styles.rightImage} className={`erp-right ${extraClass}`}>
//       <img
//         src="/assets/img/Erpsection/E2.png"
//         alt="ERP Dashboard"
//         style={styles.heroImg}
//         className="erp-img"
//       />
//       <div style={styles.floatingCard} className="erp-float-card">
//         <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>Production Growth</p>
//         <h3 style={{ margin: 0, color: '#00ff88' }}>+28%</h3>
//       </div>
//     </div>
//   );

//   const bullets = [
//     '15+ Years of Enterprise Software Experience',
//     'Industry-Focused ERP Consultants & Engineers',
//     'Manufacturing, Textile & Distribution Domain Experts',
//   ];

//   return (
//     <div style={styles.wrapper}>
//       <div style={styles.container} className="erp-container">

//         <div style={styles.leftContent} className="erp-left">
//           <p style={styles.badge} className="erp-badge">
//             #1 ERP SOLUTIONS & DIGITAL LIFECYCLE TRANSFORMATION PARTNER
//           </p>

//           <HeroImage extraClass="erp-img-mobile" />

//           <h1 style={styles.mainHeading} className="erp-heading">
//             Enterprise Resource Planning
//             <br />
//             <span style={styles.headingAccent}>(ERP) Software Services</span>
//           </h1>

//           <div style={styles.bulletList} className="erp-highlight">
//             {bullets.map((item, i) => (
//               <div key={i} style={styles.bulletItem}>
//                 <span style={styles.bulletIcon}>
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                     <circle cx="12" cy="12" r="12" fill="#007bff" opacity="0.15"/>
//                     <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#007bff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
//                   </svg>
//                 </span>
//                 <span style={styles.bulletText}>{item}</span>
//               </div>
//             ))}
//           </div>

//           {/* <button
//             style={styles.ctaButton}
//             className="erp-btn"
//             onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0056d2'}
//             onMouseLeave={e => e.currentTarget.style.backgroundColor = '#007bff'}
//           >
//             Request a demo
//             <svg width="20" height="20" viewBox="0 0 24 24"
//               fill="none" stroke="currentColor" strokeWidth="2"
//               strokeLinecap="round" strokeLinejoin="round"
//               style={{ marginLeft: '10px' }}>
//               <line x1="5" y1="12" x2="19" y2="12"></line>
//               <polyline points="12 5 19 12 12 19"></polyline>
//             </svg>
//           </button> */}
//           <a
//             href="https://cal.com/galaxyerp-team-brxd8h/30min?month"
//             target="_blank"
//             rel="noreferrer"
//             style={styles.ctaButton}
//             className="erp-btn"
//             onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0056d2'}
//             onMouseLeave={e => e.currentTarget.style.backgroundColor = '#007bff'}
//           >
//             Request a demo
//             <svg width="20" height="20" viewBox="0 0 24 24"
//               fill="none" stroke="currentColor" strokeWidth="2"
//               strokeLinecap="round" strokeLinejoin="round"
//               style={{ marginLeft: '10px' }}>
//               <line x1="5" y1="12" x2="19" y2="12"></line>
//               <polyline points="12 5 19 12 12 19"></polyline>
//             </svg>
//             </a>
//         </div>

//         <HeroImage extraClass="erp-img-desktop" />
//       </div>

//       <style>{`
//         .erp-img-mobile { display: none !important; }
//         .erp-img-desktop { display: flex !important; }

//         @media (max-width: 768px) {
//           .erp-container { grid-template-columns: 1fr !important; gap: 0px !important; }
//           .erp-img-desktop { display: none !important; }
//           .erp-img-mobile {
//             display: flex !important;
//             position: relative !important;
//             max-width: 360px !important;
//             width: 100% !important;
//             margin: 0 0 24px 0 !important;
//           }
//           .erp-img-mobile .erp-float-card { right: 0px !important; }
//           .erp-heading { font-size: 28px !important; }
//           .erp-badge { font-size: 12px !important; }
//         }

//         @media (max-width: 480px) {
//           .erp-img-mobile { max-width: 300px !important; }
//           .erp-heading { font-size: 21px !important; letter-spacing: 0 !important; }
//           .erp-btn { font-size: 14px !important; padding: 10px 20px !important; }
//         }

//         @media (max-width: 390px) {
//           .erp-img-mobile { max-width: 240px !important; }
//           .erp-heading { font-size: 17px !important; line-height: 1.35 !important; }
//           .erp-badge { font-size: 9.5px !important; letter-spacing: 0.8px !important; }
//           .erp-btn { font-size: 13px !important; padding: 9px 16px !important; }
//         }
//       `}</style>
//     </div>
//   );
// };

// const styles = {
//   wrapper: {
//     backgroundColor: '#05070a',
//     minHeight: '100vh',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
//     color: '#fff',
//     padding: '80px 5%',
//   },
//   container: {
//     display: 'grid',
//     gridTemplateColumns: '1fr 1fr',
//     gap: '50px',
//     maxWidth: '1200px',
//     width: '100%',
//     alignItems: 'center',
//   },
//   leftContent: { textAlign: 'left' },
//   badge: {
//     fontSize: '14px',
//     fontWeight: 'bold',
//     letterSpacing: '1.5px',
//     marginBottom: '20px',
//     opacity: 0.8,
//     display: 'block',
//   },
//   mainHeading: {
//     fontSize: '38px',
//     lineHeight: '1.25',
//     marginBottom: '28px',
//     fontWeight: '800',
//     color: '#ffffff',
//     letterSpacing: '0.3px',
//   },
//   headingAccent: {
//     color: '#4facfe',
//   },
//   bulletList: {
//     marginBottom: '32px',
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '12px',
//   },
//   bulletItem: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '14px',
//     padding: '13px 18px',
//     backgroundColor: '#0d1117',
//     borderRadius: '10px',
//     border: '1px solid #1a2332',
//   },
//   bulletIcon: {
//     flexShrink: 0,
//     display: 'flex',
//     alignItems: 'center',
//   },
//   bulletText: {
//     fontSize: '15px',
//     color: '#cdd6e0',
//     fontFamily: 'Open Sans, sans-serif',
//     lineHeight: '1.5',
//   },
//   ctaButton: {
//     backgroundColor: '#007bff',
//     color: 'white',
//     padding: '13px 28px',
//     border: 'none',
//     borderRadius: '25px',
//     fontSize: '16px',
//     cursor: 'pointer',
//     transition: 'background-color 0.3s',
//     display: 'inline-flex',
//     alignItems: 'center',
//     textDecoration: 'none',
//   },
//   rightImage: {
//     position: 'relative',
//     display: 'flex',
//     justifyContent: 'center',
//   },
//   heroImg: {
//     width: '100%',
//     borderRadius: '15px',
//     boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
//     border: '1px solid #333',
//   },
//   floatingCard: {
//     position: 'absolute',
//     top: '20px',
//     right: '-20px',
//     backgroundColor: '#1a1d23',
//     padding: '15px',
//     borderRadius: '10px',
//     border: '1px solid #333',
//     boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
//   },
// };

// export default ErpSection;

/*center*/

import React from 'react';

const ErpSection = () => {
  const HeroImage = ({ extraClass = '' }) => (
    <div style={styles.rightImage} className={`erp-right ${extraClass}`}>
      <img
        src="/assets/img/Erpsection/E2.png"
        alt="ERP Dashboard"
        style={styles.heroImg}
        className="erp-img"
      />
      <div style={styles.floatingCard} className="erp-float-card">
        <p style={{ margin: 0, fontSize: '12px', color: '#888' }}>Production Growth</p>
        <h3 style={{ margin: 0, color: '#00ff88' }}>+28%</h3>
      </div>
    </div>
  );

  const bullets = [
    '15+ Years of Enterprise Software Experience',
    'Industry-Focused ERP Consultants & Engineers',
    'Manufacturing, Textile & Distribution Domain Experts',
  ];

  return (
    <div style={styles.wrapper}>
      <div style={styles.container} className="erp-container">

        <div style={styles.leftContent} className="erp-left">
          <p style={styles.badge} className="erp-badge">
            #1 ERP SOLUTIONS & DIGITAL LIFECYCLE TRANSFORMATION PARTNER
          </p>

          <HeroImage extraClass="erp-img-mobile" />

          <h1 style={styles.mainHeading} className="erp-heading">
            Enterprise Resource Planning
            <br />
            <span style={styles.headingAccent}>(ERP) Software Services</span>
          </h1>

          <div style={styles.bulletList} className="erp-highlight">
            {bullets.map((item, i) => (
              <div key={i} style={styles.bulletItem}>
                <span style={styles.bulletIcon}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="12" fill="#007bff" opacity="0.15"/>
                    <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#007bff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
                <span style={styles.bulletText}>{item}</span>
              </div>
            ))}
          </div>
 
          <a
            href="https://cal.com/galaxyerp-team-brxd8h/30min?month"
            target="_blank"
            rel="noreferrer"
            style={styles.ctaButton}
            className="erp-btn"
            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#0056d2'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = '#007bff'}
          >
            Request a demo
            <svg width="20" height="20" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round"
              style={{ marginLeft: '10px' }}>
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </a>
        </div>

        <HeroImage extraClass="erp-img-desktop" />
      </div>

      <style>{`
        .erp-img-mobile { display: none !important; }
        .erp-img-desktop { display: flex !important; }

        @media (max-width: 768px) {
          .erp-container { grid-template-columns: 1fr !important; gap: 0px !important; }
          .erp-img-desktop { display: none !important; }
          .erp-img-mobile {
            display: flex !important;
            position: relative !important;
            max-width: 360px !important;
            width: 100% !important;
            margin: 0 auto 24px auto !important;
            align-self: center !important;
          }

          /* Growth card: image ni andar rahe mobile par */
          .erp-img-mobile .erp-float-card {
            right:-20px !important;
            top: 12px !important;
          }

          /* Center all left content on mobile */
          .erp-left {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            text-align: center !important;
          }

          .erp-heading { font-size: 28px !important; text-align: center !important; }
          .erp-badge { font-size: 12px !important; text-align: center !important; }
          .erp-highlight { width: 100% !important; }
          .erp-btn { align-self: center !important; }
        }

        @media (max-width: 480px) {
          .erp-img-mobile { max-width: 300px !important; }
          .erp-heading { font-size: 21px !important; letter-spacing: 0 !important; }
          .erp-btn { font-size: 14px !important; padding: 10px 20px !important; }
          .erp-img-mobile .erp-float-card { right: -20px !important; top: 10px !important; }
        }

        @media (max-width: 390px) {
          .erp-img-mobile { max-width: 240px !important; }
          .erp-heading { font-size: 17px !important; line-height: 1.35 !important; }
          .erp-badge { font-size: 9.5px !important; letter-spacing: 0.8px !important; }
          .erp-btn { font-size: 13px !important; padding: 9px 16px !important; }
          .erp-img-mobile .erp-float-card { right: -20px !important; top: 8px !important; padding: 10px !important; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  wrapper: {
    backgroundColor: '#05070a',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    color: '#fff',
    padding: '80px 5%',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '50px',
    maxWidth: '1200px',
    width: '100%',
    alignItems: 'center',
  },
  leftContent: { textAlign: 'left' },
  badge: {
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '1.5px',
    marginBottom: '20px',
    opacity: 0.8,
    display: 'block',
  },
  mainHeading: {
    fontSize: '38px',
    lineHeight: '1.25',
    marginBottom: '28px',
    fontWeight: '800',
    color: '#ffffff',
    letterSpacing: '0.3px',
  },
  headingAccent: {
    color: '#4facfe',
  },
  bulletList: {
    marginBottom: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  bulletItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    padding: '13px 18px',
    backgroundColor: '#0d1117',
    borderRadius: '10px',
    border: '1px solid #1a2332',
  },
  bulletIcon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  bulletText: {
    fontSize: '15px',
    color: '#cdd6e0',
    fontFamily: 'Open Sans, sans-serif',
    lineHeight: '1.5',
  },
  ctaButton: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '13px 28px',
    border: 'none',
    borderRadius: '25px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  rightImage: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  heroImg: {
    width: '100%',
    borderRadius: '15px',
    boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
    border: '1px solid #333',
  },
  floatingCard: {
    position: 'absolute',
    top: '20px',
    right: '-20px',  
    backgroundColor: '#1a1d23',
    padding: '15px',
    borderRadius: '10px',
    border: '1px solid #333',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
  },
};

export default ErpSection;